// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2R1HL","label":"CategoryService_label__1MAeU","location":"CategoryService_location__3v_xx"};